// Emoji mapping utility for suggested questions

/**
 * Keyword-emoji pairs sorted by keyword length (longest first) for predictable matching.
 * Longer keywords are checked first to ensure more specific matches take priority.
 * E.g., "reschedule" should match before "schedule"
 */
const emojiKeywords: Array<[string, string]> = [
  // Sorted by length descending, then alphabetically for same length
  ['reschedule', '🔄'],
  ['instructor', '👨‍🏫'],
  ['directions', '🗺️'],
  ['equipment', '🥋'],
  ['children', '👶'],
  ['discount', '🏷️'],
  ['duration', '⏰'],
  ['required', '📋'],
  ['schedule', '⏰'],
  ['capacity', '📊'],
  ['location', '📍'],
  ['outdoor', '🌳'],
  ['parking', '🚗'],
  ['prepare', '📋'],
  ['teacher', '👨‍🏫'],
  ['weather', '🌤️'],
  ['address', '📍'],
  ['contact', '📞'],
  ['adults', '👨‍👩‍👧'],
  ['cancel', '❌'],
  ['change', '🔄'],
  ['charge', '💰'],
  ['drinks', '🥤'],
  ['enroll', '📝'],
  ['indoor', '🏠'],
  ['refund', '💵'],
  ['snacks', '🍪'],
  ['about', 'ℹ️'],
  ['bring', '🎒'],
  ['close', '⏰'],
  ['email', '📧'],
  ['hours', '⏰'],
  ['limit', '📊'],
  ['lunch', '🍽️'],
  ['phone', '📞'],
  ['price', '💰'],
  ['reach', '📞'],
  ['staff', '👥'],
  ['start', '⏰'],
  ['where', '📍'],
  ['book', '📝'],
  ['call', '📞'],
  ['cost', '💰'],
  ['food', '🍕'],
  ['free', '🆓'],
  ['info', 'ℹ️'],
  ['join', '📝'],
  ['kids', '👶'],
  ['many', '📊'],
  ['meal', '🍽️'],
  ['need', '📋'],
  ['open', '⏰'],
  ['rain', '🌧️'],
  ['sign', '📝'],
  ['size', '📊'],
  ['team', '👥'],
  ['time', '⏰'],
  ['wear', '👕'],
  ['what', '💡'],
  ['when', '⏰'],
  ['age', '👶'],
  ['fee', '💰'],
  ['how', '💡'],
  ['map', '🗺️'],
  ['pay', '💰'],
  ['who', '👤'],
  ['why', '💡'],
];

/**
 * Get an emoji that matches the content of a question
 *
 * Keywords are checked longest-first to ensure more specific matches win.
 * E.g., "reschedule" matches before "schedule".
 *
 * @param question - The question text to analyze
 * @returns An emoji that best matches the question topic, or a default emoji
 *
 * @example
 * getQuestionEmoji("What time do you open?") // Returns "⏰"
 * getQuestionEmoji("Where is the parking?") // Returns "🚗"
 * getQuestionEmoji("Random question") // Returns "💬"
 */
export function getQuestionEmoji(question: string): string {
  const q = question.toLowerCase();

  // Check each keyword (already sorted by length descending)
  for (const [keyword, emoji] of emojiKeywords) {
    if (q.includes(keyword)) {
      return emoji;
    }
  }

  // Default emoji for unmatched questions
  return '💬';
}

export default getQuestionEmoji;
